import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import { AssistantAvatarMood } from "@/ui/AssistantAvatar/assistantAvatarConfig";
import { AVATAR_PART } from "@/ui/AssistantAvatar/assistantAvatarMotion";

type MouthRenderer = FC<{ ink: string }>;

const Smile: MouthRenderer = ({ ink }) => <path d="M51 75 Q60 84 69 75" fill="none" stroke={ink} strokeWidth={3.2} strokeLinecap="round" />;

const MOUTHS: Record<AssistantAvatarMood, MouthRenderer> = {
	[AssistantAvatarMood.Idle]: Smile,
	[AssistantAvatarMood.NeedsYou]: Smile,
	[AssistantAvatarMood.Thinking]: ({ ink }) => <path d="M56 78 Q61 76 67 77" fill="none" stroke={ink} strokeWidth={3} strokeLinecap="round" />,
	// The only mouth that moves: the talking loop scales it open and shut.
	[AssistantAvatarMood.Talking]: ({ ink }) => <ellipse className={AVATAR_PART.MOUTH} cx={60} cy={77} rx={5} ry={4.2} fill={ink} />,
	[AssistantAvatarMood.Done]: ({ ink }) => (
		<>
			<path d="M50 73 Q60 89 70 73 Z" fill={ink} />
			<path d="M55 80 Q60 84 65 80" fill={ASSISTANT_AVATAR.FACE.TONGUE} />
		</>
	),
	[AssistantAvatarMood.Oops]: ({ ink }) => <path d="M50 79 Q55 75 60 79 Q65 83 70 79" fill="none" stroke={ink} strokeWidth={3} strokeLinecap="round" />,
};

interface AvatarMouthProps {
	mood: AssistantAvatarMood;
	ink: string;
}

export const AvatarMouth: FC<AvatarMouthProps> = ({ mood, ink }) => {
	const Mouth = MOUTHS[mood];
	return <Mouth ink={ink} />;
};
